<div class="top-nav">

  <button (click)="returnToSummary()" aria-label="Back" class="btn btn-back">
    <i class="fa fa-arrow-left"></i>
    <span> review management</span>
  </button>
  <div style="flex-grow: 1">

  </div>
  <div>Reviews backlog</div>
</div>

<app-banner [info]="true" heading="Review backlog" subHeading="Revalidation submissions pending allocation">

  <div class="toolbar-content">

    <!---  <button [disabled]="pager.loading" (click)="togglePanel('sampling')" aria-label="Create sampling" class="btn no-focus"
    [class.open]="panel==='sampling'">
    <i class="fa fa-database"></i>
    <span>sample</span>
  </button>

  <button [disabled]="pager.loading || data?.length === 0" (click)="togglePanel('cohort')" aria-label="Create review cohort" class="btn no-focus"
    [class.open]="panel==='cohort'">
    <i class="fa fa-calendar"></i>
    <span>allocate</span>
  </button>-->

  <button [disabled]="loading" (click)="togglePanel('filter')" aria-label="Filter reviews"
    class="btn btn-back no-focus" [class.open]="panel==='filter'">
    <i class="fa fa-search"></i>
    <span>filter</span>
  </button>
</div>

</app-banner>

<app-collapsible [trigger]="panel==='filter'">
  <div class="dropdown-panel">
    <h4>
      <span>Filter</span>
      <button (click)="clearFilterParams()" [disabled]="!hasFilterParams" class="btn-default btn-close mr-4">
        <i class="fa fa-trash"></i></button>
        <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
      </h4>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group filter-param" [class.active]="!!filterParams.registrationNumber">
            <div class="filter-header">
              <label>Registration number</label>
              <button [class.active]="activeFilterParams.registrationNumber !== undefined" class="btn-clear-filter"
                (click)="clearFilter('registrationNumber')"><i class="fa fa-close"></i></button>
              </div>
              <input type="text" class="form-control" [(ngModel)]="filterParams.registrationNumber"
                placeholder="Registration number..." />

              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group filter-param" [class.active]="!!filterParams.registrationStatus">
                <div class="filter-header">
                  <label>Registration status</label>
                  <button [class.active]="activeFilterParams.registrationStatus !== undefined" class="btn-clear-filter"
                    (click)="clearFilter('registrationStatus')"><i class="fa fa-close"></i></button>
                  </div>
                  <mat-select class="form-control" [(ngModel)]="filterParams.registrationStatus"
                    placeholder="Select a status...">
                    @for (item of RegistrationStatus | keys; track item) {
                      <mat-option [value]="item.key">
                        {{ item.value }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group filter-param" [class.active]="filterParams.reviewSelectionStatus !== undefined">
                  <div class="filter-header">
                    <label>Selection reason</label>
                    <button [class.active]="activeFilterParams.reviewSelectionStatus !== undefined" class="btn-clear-filter"
                      (click)="clearFilter('reviewSelectionStatus')"><i class="fa fa-close"></i></button>
                    </div>
                    <mat-select class="form-control" [(ngModel)]="filterParams.reviewSelectionStatus"
                      placeholder="Why selected for review...">
                      @for (item of filterReviewSelectionStatuses; track item) {
                        <mat-option [value]="item.key">
                          {{ item.value | caseSplit }}
                        </mat-option>
                      }
                    </mat-select>

                  </div>
                  <div class="form-group filter-param" [class.active]="filterParams.maxDaysLate !== undefined">
                    <label style="display:flex"><span style="flex-grow:1">Days
                      late (upper limit)</span><span>{{filterParams.maxDaysLate}}</span></label>
                      <mat-slider [max]="7" [min]="0"><input matSliderThumb [(ngModel)]="filterParams.maxDaysLate"/>
                      </mat-slider>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group filter-param" [class.active]="filterParams.inRemediationThisYear !== undefined">
                      <div class="filter-header">
                        <label>Remediation</label>
                        <button [class.active]="activeFilterParams.inRemediationThisYear !== undefined" class="btn-clear-filter"
                          (click)="clearFilter('inRemediationThisYear')"><i class="fa fa-close"></i></button>
                        </div>
                        <div style="overflow:hidden;">
                          <mat-radio-group style="white-space: nowrap" [(ngModel)]="filterParams.inRemediationThisYear">

                            <mat-radio-button [value]="true">In remediation</mat-radio-button>
                            <mat-radio-button [value]="false">Not in remediation</mat-radio-button>
                          </mat-radio-group>
                        </div>

                      </div>
                      <div class="form-group filter-param" [class.active]="filterParams.renewalDate !== undefined">
                        <div class="filter-header">
                          <label>Renewal date</label>
                          <button [class.active]="activeFilterParams.renewalDate !== undefined" class="btn-clear-filter"
                            (click)="clearFilter('renewalDate')"><i class="fa fa-close"></i></button>
                          </div>
                          <div>
                            <app-utc-date-picker [(ngModel)]="filterParams.renewalDate"></app-utc-date-picker>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <button [disabled]="!hasFilterParams || filterParamsAreActive || loading"
                        class="btn btn-primary btn-lg btn-block" (click)="load()">Apply filter</button>
                      </div>
                    </div>


                    <!---
                    <div class="row">
                      <div class="col-md-6">
                      </div>
                      <div class="col-md-4">
                        <button [disabled]="!hasFilterParams || filterParamsAreActive" class="btn btn-primary btn-lg btn-block"
                        (click)="load()">Apply</button>
                      </div>
                      <div class="col-md-2">
                        <button [disabled]="!hasFilterParams && !filterParamsAreActive" class="btn btn-default btn-lg btn-block"
                        (click)="clearFilter()">Clear</button>
                      </div>
                    </div>-->

                  </div>
                </app-collapsible>

                <app-collapsible [trigger]="panel==='cohort'">
                  <div class="dropdown-panel">

                    <h4>
                      <span>Allocate to reviewers</span>
                      <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
                    </h4>

                    <app-review-cohort-create (created)="cohortCreated()"></app-review-cohort-create>

                  </div>
                </app-collapsible>
                <app-collapsible [trigger]="panel==='sampling'">
                  <div class="dropdown-panel">
                    <h4>
                      <span>Select for review</span>
                      <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
                    </h4>
                    <app-sampling (created)="samplingCreated($event)"></app-sampling>
                  </div>
                </app-collapsible>


                <app-collapsible [trigger]="hasActiveFilterParams">
                  <div class="filter-param-info">
                    <div style="flex-grow:1">
                      @for (item of activeFilterParamsInfo; track item) {
                        <div class="filter-param-info-item">{{ item.value }} <button
                          class="btn-clear-filter" (click)="clearFilter(item.key)"><i class="fa fa-close"></i></button></div>
                        }

                      </div>
                      <button class="btn btn-default btn-clear-all-filters" (click)="clearAllFilters()">Clear all</button>
                    </div>
                  </app-collapsible>

                  <app-pager [datasource]="service.getBacklog.bind(service)" (loaded)="onLoad($event)"></app-pager>
                  <div class="content no-boxes fadein">

                    @if (!loading) {
                      @if (data.length > 0) {
                        <div style="padding-bottom: 20px">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Renewal date</th>
                                <th>Registrant</th>
                                <th>Selection</th>
                                <th class="text-right">Days late</th>
                                <th class="text-right">Remediation</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (row of data; track row) {
                                <tr>
                                  <td>{{ row.renewalDate | date: 'dd/MM/yyyy' }}</td>
                                  <td>{{ row.registrationNumber }} - {{ row.registrantName }} </td>
                                  <td> {{ ReviewSelectionStatus[row.reviewSelectionStatus] | caseSplit }}</td>
                                  <td class="text-right"> {{ row.daysLate || '-' }}</td>
                                  <td class="text-right"> {{ row.inRemediationThisYear | friendlyBoolean }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      } @else {
                        <div class="no-data">
                          No results for the given criteria
                        </div>
                      }
                    }
                  </div>




